// extracted by mini-css-extract-plugin
export var dropdown = "_wd-0";
export var imageWrapper = "_wd-3";
export var itemNameContainer = "_wd-1";
export var productImage = "_wd-2";
export var spinnerWrapper = "_wd-4";